export default "__VITE_ASSET__qQyTU8qn__"